import { RBACPermissions } from '../rbca/rbac-types';
import { Maybe, StrategyType } from '../../shared/types/generated';

export const SETTING_ROUTES = [
  {
    path: '/setting/account',
    name: 'My Account',
  },
  {
    path: '/setting/strategy',
    name: 'Strategy',
    permissions: RBACPermissions.STRATEGIES
  },
  {
    path: '/setting/broker-connection',
    name: 'Broker Connection',
  },
  {
    path: '/setting/risk-management',
    name: 'Risk Management',
    permissions: RBACPermissions.RISKS

  },
  {
    path: '/setting/platform-status',
    name: 'Platform Status',
    permissions: RBACPermissions.BUILD
  },
  {
    path: '/setting/flush',
    name: 'Flush',
    permissions: RBACPermissions.FLUSH
  },
];

export const getStrategyType = (
  strategyType?: Maybe<StrategyType> | undefined,
): string => {
  let strategy: string;
  switch (strategyType) {
    case StrategyType.Against:
      strategy = 'Against Movement';
      break;
    case StrategyType.Favor:
      strategy = 'Favor Movement';
      break;
    case StrategyType.SafetyLoss:
      strategy = 'Safety Loss';
      break;
    case StrategyType.Cycles:
      strategy = 'Cycles';
      break;
    case StrategyType.RedAgainst:
      strategy = 'Red against';
      break;
    case StrategyType.MaxDayProfit:
      strategy = 'Max Day Profit';
      break;
    case StrategyType.MinDayProfit:
      strategy = 'Min Day Profit';
      break;
    default:
      strategy = 'Safety Profit';
      break;
  }

  return strategy;
};

export const getDecimals = (num: number): number => {
  const stringNumberArray = num.toString().split('.');
  if (stringNumberArray.length && stringNumberArray[1]) {
    return stringNumberArray[1].length;
  }
  return 0;
};
